enum dataHooks {
  errorApp = 'error-app',
  backgroundImage = 'background-image',
  errorLayout = 'error-layout',
  errorDescription = 'error-description',
  errorRequestId = 'error-request-id',
  errorButton = 'error-button',
  errorCode = 'error-code',
  symphonyCollage = 'symphony-collage',
  symphonyHeader = 'symphony-header',
  symphonyMenuButton = 'symphony-menu-button',
  root = 'root',
}

export default dataHooks;
